import { createAsyncThunk } from "@reduxjs/toolkit";
import { INotification, INotificationCreateRule } from "./notification.types";
import { api } from "../../api/api";
import { ERROR_MESSAGES } from "../../constants/enums";

export const fetchNotifications = createAsyncThunk<
  {
    notifications: INotification[];
    totalCount: number;
  },
  {
    pageNumber: number;
    rowInPerPage: number;
  }
>(
  "notifications/fetchNotifications",
  async ({ pageNumber, rowInPerPage }, { rejectWithValue }) => {
    try {
      const finalUrl = `/notification/get-notifiction?pageNo=${pageNumber}&itemPerPage=${rowInPerPage}`;

      const res = await api.get(finalUrl);
      const data: INotification[] = res.data.data;
      return {
        notifications: data,
        totalCount: res.data.totalRecords,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);

export const fetchNotificationsRules = createAsyncThunk<
  {
    notificationsRules: INotificationCreateRule[];
  },
  {
    pageNumber: number;
    rowsInPerPage: number;
    limit: number;
    status: string;
  }
>(
  "notifications/fetchNotificationsRules",
  async ({ pageNumber, rowsInPerPage, limit, status }, { rejectWithValue }) => {
    try {
      const finalUrl = `/notification/get-notification-rule?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&limit=${limit}`;

      if(status !== "-1") {
        finalUrl.concat(`&status=${status}`);
      }
      const res = await api.get(finalUrl);
      const data: INotificationCreateRule[] = res.data.data;
      return {
        notificationsRules: data,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);


export const upsertNotificationRule = createAsyncThunk<
  {
    data: string;
  },
  {
    notificationRuleData: INotificationCreateRule;
  }
>(
  "notifications/upsertNotificationRule",
  async ({ notificationRuleData }, { rejectWithValue }) => {
    try {
      const finalUrl = `/notification/create-notification-rule`;

      const res = await api.post(finalUrl, {...notificationRuleData});
      const data: INotificationCreateRule[] = res.data.data;
      return {
        data: "success",
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);


export const upsertNotificationMarkAsRead = createAsyncThunk<
  {
    data: string;
  },
  {
    notificationCode: string;
  }
>(
  "notifications/upsertNotificationMarkAsRead",
  async ({ notificationCode }, { rejectWithValue }) => {
    try {
      const finalUrl = `/notification/mark-as-read`;

      const res = await api.post(finalUrl, {
        notification_code: notificationCode,
      });
      const data: INotificationCreateRule[] = res.data.data;
      return {
        data: "success",
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);
